import Cookie from 'js-cookie';

import createKm from '@ott/utility-create-km';
import { determineLayoutContext } from '@ott/layout-context';
import { ACTIVITY_TYPES } from '../constants';
import { Activity, TrackData } from '../types';

const getLayout = (): 'mobile' | 'desktop' => {
  const { isMobileLayout } = determineLayoutContext();

  return isMobileLayout ? 'mobile' : 'desktop';
};

const track = createKm('ActivityCard', {
  referrer: () => Cookie.get('referrer'),
  referrer_mrk: () => Cookie.get('referrer_mrk'),
  abst: () => Cookie.get('abst'),
  layout: getLayout,
});

const onLikeClick = ({
  isLikedBeforeClick,
  activity,
  trackData,
}: {
  isLikedBeforeClick: boolean;
  activity: Activity;
  trackData: TrackData;
}) => {
  const params = {
    activityId: activity.activityId,
    cardOrder: trackData.cardOrder,
    isIndividual: activity.type === ACTIVITY_TYPES.INDIVIDUAL,
    localityId: activity.localityId,
    page: trackData.page,
    id: trackData.id,
    price: activity.price,
    rating: activity.rating?.value,
    resultsCount: trackData.resultsCount,
    reviewsCount: activity.rating?.reviewsCount,
  };

  track(isLikedBeforeClick ? 'ACT_CARD_UNLIKE' : 'ACT_CARD_LIKE', params);
};

export default {
  onLikeClick,
};
